import styled from 'styled-components';

export const CartEntryTitle = styled.div`
  font-size: 0.9rem;
  color: ${Styles.color.black};
  line-height: 1.2;
  font-weight: ${Styles.fontWeight.heavy};
  margin-bottom: 4px;
`;
